import z from 'zod';
export const TIME_UNIT_CALENDAR_DAYS = 'calendar_days';
export const TIME_UNIT_CALENDAR_MONTHS = 'calendar_months';
export const TIME_UNIT_WORKING_DAYS = 'working_days';
export const TIME_UNITS = [
    TIME_UNIT_WORKING_DAYS,
    TIME_UNIT_CALENDAR_DAYS,
    TIME_UNIT_CALENDAR_MONTHS,
];
export const timeUnitValue = z.enum(TIME_UNITS);
export const timeUnit = (value) => timeUnitValue.parse(value);
export const isTimeUnit = (value) => timeUnitValue.safeParse(value).success;
//# sourceMappingURL=time-unit.js.map